import { withResolvers } from '~/utils/promises';

// moved to a separate file so it can be imported in the root to make vite happy
export const importPromise = withResolvers<void>();

// see `waitForImport()`
export const importModifications = withResolvers<void>();
